import React from "react"
import Icon from "../Icon"
import Cropper from "react-easy-crop"
import pica from 'pica'

import styles from "./PhotoUpload.module.css"
import {IMAGE_TYPE_JPG, IMAGE_TYPE_PNG} from "../../constants/image"
import {compressImageFile} from "../../utils/fileUtils"
import {logError} from "../../utils/errorHandlingUtils"

class PhotoUpload extends React.PureComponent {
    
    state = {
        crop: {x: 0, y: 0},
        zoom: 1
    }

    static defaultProps = {
        imageUrl: "", 
        onChange: ()=>{}, 
        accept: "image/png, image/jpeg", 
        buttonText: "Upload Image", 
        maxImageDimensions: 500,
        customStyle: {},
        onCrop: () => {},
        cropWidth: null,
        cropHeight: null,
        cropShape: 'round',
        compressImage: true,
    }

    fileInput = null

    handleSelectImage = async e => {
        const {onChange, maxImageDimensions, compressImage} = this.props
        let localImageUrl, imageFile
        try {
            // Ensure files are selected
            if(e.target.files.length > 0){
                //validate file type
                const fileType = e.target.files[0].type.toLowerCase();
                if (fileType !== IMAGE_TYPE_JPG && fileType !== IMAGE_TYPE_PNG){
                    return
                }
                if (compressImage){
                    //if set to auto compress images
                    let compressedFile = await compressImageFile(e.target.files[0], maxImageDimensions)
                    if (!compressedFile) return
                    imageFile = compressedFile
                } else {
                    imageFile = e.target.files[0]
                }
                // Create object URL for the selected image
                localImageUrl = URL.createObjectURL(imageFile)
                onChange(localImageUrl, imageFile)
            } else  logError("PhotoUpload failed to import photo")
        } catch (error) {
            logError("Error handling selected image", error);
        }
    }

    handleClick = () => {
        if (this.fileInput) this.fileInput.click()
    } 

    handleCropComplete = async (croppedArea, croppedAreaPixels) => {
        try {
            if (isNaN(croppedAreaPixels.x)) return
            const {imageUrl, imageFile, onCrop, cropWidth, cropHeight} = this.props
            const croppedImageFile = await this.getCroppedImage(imageUrl, croppedAreaPixels, cropWidth, cropHeight, imageFile.type)
            if (croppedImageFile) {
                onCrop(croppedImageFile);
            }
        } catch (error) {
            logError("Error completing crop", error);
        }
    }

    createImage = (url) => new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', error => reject(error))
        image.src = url
    })

    getCroppedImage = async (imageUrl, pixelCrop, cropWidth, cropHeight, fileType) => {
        let image
        try {
            image = await this.createImage(imageUrl)
        } catch (error) {
            logError("Failed to create image", error);
            return null;
        }
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            logError("Failed to get 2D context");
            return null;
        }
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        
      
        // ctx.imageSmoothingQuality = "high";
      
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          canvas.width,
          canvas.height
        );

        const resultCanvas = document.createElement("canvas");
        resultCanvas.width = canvas.width
        resultCanvas.height = canvas.height

        const picaTool = pica()
        const picaCanvas = await picaTool.resize(canvas, resultCanvas, {
            unsharpAmount: 0,
            unsharpRadius: 0,
            unsharpThreshold: 0,
            quality: 1,
        });
        
        // As a blob
        return new Promise((resolve, reject) => {
          picaCanvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            fileType,
            1
          );
        });
      }

    componentWillUnmount() {
        if (this.props.imageUrl) {
            URL.revokeObjectURL(this.props.imageUrl);
        }
    }

    render(){
        const {
            imageUrl,
            imageFile, 
            accept, 
            buttonText, 
            customStyle,
            cropWidth,
            cropHeight,
            cropShape,
            onCrop
        } = this.props
        const {
            crop,
            zoom
        } = this.state
        const imageStyle = imageUrl ? styles.image : ""
        return (
            <div className={`${styles.container} upload ${imageStyle}`} style={customStyle}  onClick={!imageUrl || !onCrop ? this.handleClick : ()=>{}}>
                <input type="file" ref={ref => this.fileInput = ref} onChange={this.handleSelectImage} accept={accept}></input>
                {
                    imageUrl && imageFile && cropWidth && cropHeight?
                    <div className="productImage">
                        <Cropper 
                            image={imageUrl}
                            crop={crop}
                            zoom={zoom}
                            aspect={cropWidth/cropHeight}
                            cropShape={cropShape}
                            onCropChange={crop => this.setState({crop})}
                            onZoomChange={zoom => this.setState({zoom})}
                            onCropComplete={this.handleCropComplete}
                        />
                    </div>
                    :
                    (imageUrl && (!cropWidth || !cropHeight)) || (imageUrl && !imageFile)?
                    <img className="productImage" src={imageUrl} />
                    :
                    <div className="symbol">
                        <Icon icon="photo-camera" />
                        <button className="button white">{buttonText}</button>
                    </div>
                }
            </div>
        )
    }
}

export default PhotoUpload